import { render, staticRenderFns } from "./Finalizar.vue?vue&type=template&id=1315dbc1&scoped=true"
import script from "./Finalizar.vue?vue&type=script&lang=js"
export * from "./Finalizar.vue?vue&type=script&lang=js"
import style0 from "./Finalizar.vue?vue&type=style&index=0&id=1315dbc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1315dbc1",
  null
  
)

export default component.exports